$shm_hitalama_map_widget_float_application $shm_hitalama_map_widget_float
	model $shm_hitalama_components_demo
		definition <= definition $shm_hitalama_map_widget_entity_custom
		extra_context <= application_context *
		source_text* <= source_text* \
	content <= application_content /$mol_view
